<template>
  <div>
    <va-modal
      id="agendaEventFormModal"
      ref="agendaEventFormModal"
      class="evollu-form"
      size="medium"
      :value="showModal"
      :noOutsideDismiss="true"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.cancel')"
      :dangerText="$t('modals.buttons.delete')"
      :showDelete="isUpdating && mainTabValue === 0"
      :showOkay="mainTabValue === 0"
      :okDisabled="isSubmitting || !canSubmitForm "
      @ok="submit"
      @cancel="cancel"
      @remove="remove">
      <div slot="header" class="modal-title">
        {{ modalTitle }}
      </div>

      <div class="row no-gutters">
        <va-tabs v-model="mainTabValue" style="border-width: 2px">
          <va-tab
            v-for="tab in mainViewType"
            :key="tab"
          >
            {{ tab === 'eventDetails' ? $t("activities_agenda.agenda.event_section") : $t("activities_agenda.agenda.status_follow_up") }}
          </va-tab>
        </va-tabs>
        <div class="col-12 mt-4" v-if="mainTabValue === 0">
          <!--<div>
            <label class="form-label section-label">{{ $t("activities_agenda.agenda.event_section") }}</label>
          </div>-->

          <div class="row">
            <div class="col-6">
              <p>{{$t("entities.activities.revision.activity")}}: <span class="is-bold"> {{selectedActivity.name}} </span> </p>
              <p>{{ $t("facility.inputs.entity") }}: <span class="is-bold">{{ selectedEntity.name }}</span>
              </p>
            </div>
          </div>
          <div v-if="isLoading">
            <LoadingPlaceholder/>
          </div>
          <div v-else>
            <div class="row" v-if="isExternalBooking">
              <div class="col-6">
                <div>
                  <label class="form-label">{{ $t("activities_agenda.agenda.origin_entity") }}:</label>
                  <multiselect
                    v-model="form.originEntity"
                    :options="originEntitiesOptions"
                    track-by="id"
                    label="name"
                    select-label=""
                    selected-label=""
                    deselect-label=""
                    :placeholder="$t('activities_agenda.agenda.origin_entity')"
                    :allow-empty="false"
                    :multiple="false"
                    :searchable="true"
                    :disabled="originEntitiesOptions.length <= 1">
                    <template slot="clear">
                <span class="multiselect__clear" v-if="form.originEntity"
                      @mousedown.prevent.stop="() => form.originEntity = null"></span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-6">
                <div>
                  <label class="form-label">{{ $t("activities_agenda.agenda.origin_facility") }}:</label>
                  <multiselect
                    v-model="form.originFacility"
                    :options="originFacilitiesOptions"
                    track-by="id"
                    label="name"
                    select-label=""
                    selected-label=""
                    deselect-label=""
                    :placeholder="$t('activities_agenda.agenda.origin_facility')"
                    :allow-empty="false"
                    :multiple="false"
                    :searchable="true"
                    :disabled="originFacilitiesOptions.length <= 1">
                    <template slot="clear">
                <span class="multiselect__clear" v-if="form.originFacility"
                      @mousedown.prevent.stop="() => form.originFacility = null"></span>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div>
                  <label class="form-label">{{ $t("agenda.appointments.facility") }}:</label>
                  <multiselect
                    v-model="form.facility"
                    :options="facilitiesOptions"
                    track-by="id"
                    label="name"
                    select-label=""
                    selected-label=""
                    deselect-label=""
                    :placeholder="$t('agenda.appointments.facility')"
                    :allow-empty="true"
                    :multiple="false"
                    :searchable="true"
                    :disabled="facilitiesOptions.length <= 1">
                    <template slot="clear">
                <span class="multiselect__clear" v-if="form.facility"
                      @mousedown.prevent.stop="() => form.facility = null"></span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <!-- Event booking type -->
              <div class="col-6" v-if="bookingTypes.length > 1">
                <div>
                  <label class="form-label">{{ $t("agenda.appointments.appointment_type") }}:</label>
                  <multiselect
                    v-model="form.bookingType"
                    :options="bookingTypes"
                    track-by="id"
                    label="name"
                    :custom-label="(elem) => $t(`activities_agenda.agenda.booking_types.${elem.slug}`)"
                    select-label=""
                    selected-label=""
                    deselect-label=""
                    :placeholder="$t('agenda.appointments.appointment_type')"
                    :allow-empty="true"
                    :multiple="false"
                    :searchable="true"
                  >
                    <template slot="clear">
                        <span class="multiselect__clear" v-if="form.bookingType"
                              @mousedown.prevent.stop="() => form.bookingType = null"></span>
                    </template>
                    <span slot="noResult">{{ "patients.noResults"| translate }}</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Event start -->
              <div class="col-6">
                <div
                  class="form-group"
                  :class="{
                  'has-error': formErrors.has('start')}"
                >
                  <div class="input-group">
                    <label class="form-label">{{ $t("agenda.availability.start") }}:</label>
                    <DatePicker
                      id="event-start"
                      class="w-100"
                      v-model="form.start"
                      :config="datePickerConfig"
                      :placeholder="$t('agenda.availability.start')"
                      :error="formErrors.has('start')"
                      :error-messages="[$t(formErrors.get('start'))]"
                    />
                  </div>
                </div>
              </div>

              <!-- Event end -->
              <div class="col-6">
                <div
                  class="form-group"
                  :class="{'has-error': formErrors.has('end')}"
                >
                  <div class="input-group">
                    <label class="form-label">{{ $t("agenda.availability.end") }}:</label>
                    <DatePicker
                      id="event-end"
                      class="w-100"
                      v-model="form.end"
                      :config="datePickerConfig"
                      :placeholder="$t('agenda.availability.end')"
                      :error="formErrors.has('end')"
                      :error-messages="[$t(formErrors.get('end'))]"
                      @input="formErrors.clear('end')"
                    />

                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Event payment type -->
              <div class="col-6" v-if="paymentTypes.length > 1">
                <div>
                  <label class="form-label">{{ $t("activities_agenda.agenda.payment_type") }}:</label>
                  <multiselect
                    v-model="form.paymentType"
                    :options="paymentTypes"
                    track-by="id"
                    label="name"
                    :custom-label="(elem) => $t(`activities_agenda.agenda.payment_types.${elem.slug}`)"
                    select-label=""
                    selected-label=""
                    deselect-label=""
                    :placeholder="$t('activities_agenda.agenda.payment_type')"
                    :allow-empty="true"
                    :multiple="false"
                    :searchable="true"
                  >
                    <template slot="clear">
                        <span class="multiselect__clear" v-if="form.paymentType"
                              @mousedown.prevent.stop="() => form.paymentType = null"></span>
                    </template>
                    <span slot="noResult">{{ "patients.noResults"| translate }}</span>
                  </multiselect>
                </div>
              </div>            </div>

            <div>
              <div class="col-12">
                <label class="form-label section-label">{{ $t("activities_agenda.agenda.person_section") }}</label>
              </div>

              <!-- Search Person -->
              <va-card style="min-height: 170px; height: 100%">
                <va-tabs v-model="tabValue" style="border-width: 2px">
                  <va-tab
                    v-for="tab in viewType"
                    :key="tab"
                  >
                    {{ $t(`activities_agenda.agenda.person_tab_selector.${tab}`) }}
                  </va-tab>
                </va-tabs>
                <div v-if="tabValue === 0" class="mt-4">
                  <PeopleSelector @selectedPerson="personSelected" />
                  <div class="row mt-4" v-if="selectedPerson">

                    <h5 class="col-12">{{ $t('activities_agenda.agenda.selected_person') }}</h5>
                    <div class="col-md-5">
                      <p>{{ $t("accounts.name") }}: <span class="is-bold">{{ handleSelectedPersonName }}</span>
                        <va-popover
                          v-if="selectedPerson && selectedPerson.id"
                          placement="top"
                          :message="$t('checkup_plus.reports.patient_details.patient_details')">
                          &ensp;<i class="clickable fa fa-external-link"  @click.prevent="openPeopleManagerPerson(selectedPerson.id)"></i>
                        </va-popover>
                      </p>
                      <p>{{ $t("people.inputs.mobile-phone") }}: <span
                        class="is-bold">{{ selectedPerson.mobilePhone }}</span></p>
                      <p>{{ $t("patients.inputs.taxCard") }}: <span class="is-bold">{{ selectedPerson.taxNr }}</span></p>
                    </div>

                    <div class="col-md-5">
                      <p>{{ $t("clinical.people.birthday") }}: <span
                        class="is-bold">{{ selectedPerson.birthdate | parseBirthdate }}</span></p>
                      <p>{{ $t("accounts.email") }}: <span class="is-bold">{{ selectedPerson.email }}</span></p>
                      <p>{{ $t("patients.inputs.healthCard") }}: <span
                        class="is-bold">{{ selectedPerson.healthNr }}</span></p>
                    </div>

                  </div>

                </div>

                <!-- ---- Person Form Creation ---- -->
                <!-- Person Name -->
                <div v-if="tabValue === 1" class="mt-4">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <va-input
                          type="text"
                          v-model="personForm.firstName"
                          :placeholder="$t('agenda.appointments.name')"
                          :label="$t('agenda.appointments.name')"
                          required
                        />
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group">
                        <va-input
                          type="text"
                          v-model="personForm.lastName"
                          :placeholder="$t('wellbeing.leads.table.last_name')"
                          :label="$t('wellbeing.leads.table.last_name')"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-label">{{$t('patients.inputs.address.country')}}</label>
                        <multiselect
                          id="country-multiselect"
                          v-model="personForm.country"
                          :options="countries"
                          track-by="code"
                          :customLabel="(country => {
                            return this.getFlagEmoji(country.code) + ' ' + country.name
                          })"
                          select-label=""
                          deselect-label="×"
                          open-direction="bellow"
                          placeholder="---"
                          :allow-empty="false"
                          :multiple="false"
                          :searchable="true"
                          @input="formErrors.clear('country')"
                        >
                          <span slot="noResult">{{$t('patients.noResults')}}</span>
                        </multiselect>
                        <div class="text-danger" v-if="formErrors.has('country')">
                          <small>
                            {{$t(formErrors.get('country'))}}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-label">{{ $t("tables.columns.birthdate") }}:</label>
                        <DatePicker
                          id="event-end"
                          class="w-100"
                          v-model="personForm.birthdate"
                          :config="birthdatePickerConfig"
                          :placeholder="$t('tables.columns.birthdate')"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <va-input
                          type="email"
                          v-model="personForm.email"
                          :placeholder="$t('accounts.email')"
                          :label="$t('accounts.email')"
                          :error="formErrors.has('email') || invalidEmail"
                          :error-messages="[$t(formErrors.get('email'))]"
                          @input="formErrors.clear('email')"
                        />
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group" style="margin-bottom:0.25rem;">
                        <label class="form-label">{{ $t("references.inputs.phone") }}</label>
                        <vue-tel-input
                          v-model="personForm.mobilePhone"
                          class="w-100"
                          maxlength="20"
                          :preferredCountries="$store.state.countries.allowed"
                          :disabledFetchingCountry="true"
                          :defaultCountry="defaultTelCountrySelection"
                          :placeholder="$t('references.inputs.phone')"
                          @validate="mobilePhoneValidation">
                        </vue-tel-input>
                        <span class="small text-danger"
                              v-show="personForm.mobilePhone !== '' && personForm.mobilePhone !== null && invalidMobilePhone">
                        {{ $t("patients.errors.invalidPhone") }}
                      </span>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <va-input
                          :label="$t('clinical.people.nif')"
                          :placeholder="$t('clinical.people.nif')"
                          v-model="personForm.taxNr"
                          :error="formErrors.has('taxNr')"
                          :error-messages="[$t(formErrors.get('taxNr'))]"
                          @input="() => {
                            formErrors.clear('taxNr')
                            this.$set(this.personForm, 'taxrNr', this.personForm.taxNr);
                          }"
                          id="editing-nif"
                          :maxlength="25"
                          />
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group">
                        <va-input
                          :label="$t('people_manager.inputs.health_nr')"
                          :placeholder="$t('people_manager.inputs.health_nr')"
                          v-model="personForm.healthNr"
                          id="editing-health-nr"
                          :error="formErrors.has('healthNr')"
                          :error-messages="[$t(formErrors.get('healthNr'))]"
                          @input="formErrors.clear('healt_nr')"
                          :maxlength="25"
                          required/>
                      </div>
                    </div>
                  </div>
                </div>
              </va-card>

            </div>
          </div>

        </div>
        <div v-if="mainTabValue === 1" class="col-12 mt-4">
          <!--<label class="is-bold form-label section-label">Seguimento</label>-->
          <div class="d-flex" v-if="hasPursuesWriteAccess">
            <div class="col-8">
              <label class="form-label">{{ $t("homelab.new_status") }}:</label>
              <multiselect
                v-model="newPursueStatus"
                :options="bookingStatuses"
                track-by="id"
                :customLabel="(elem) => $t(`activities_agenda.events.statuses.${elem.id}`)"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('agenda.inputs.status')"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
                :disabled="bookingStatuses.length <= 1">
                <template slot="clear">
                        <span class="multiselect__clear" v-if="newPursueStatus"
                              @mousedown.prevent.stop="() => newPursueStatus = null">
                        </span>
                </template>
              </multiselect>
            </div>
            <va-button class="mt-4" :disabled="newPursueStatus === null" @click="submitPursueStatus">
              {{ $t('users.create') }}
            </va-button>
          </div>


          <div class="mt-4">
            <span class="is-bold form-label section-label" style="font-size: 18px">{{ $t('menu.evocall/history') }}</span>
            <div class="row mt-2" v-for="pursue in form.pursues">
              <div class="row col-12 align-items-center" style="margin-bottom: 2px !important;">
                <div class="row" :class="{'col-10': hasPursuesWriteAccess, 'col-12': !hasPursuesWriteAccess}" style="margin-bottom: 2px !important; margin-left: -15px">
                <span class="col-12">
                <span class="is-bold fa fa-spinner"> </span> {{$t(`activities_agenda.events.statuses.${pursue.status.id}`)}}
              </span>
                  <span class="col-12">
                    <span class="is-bold fa fa-calendar"> </span> {{moment(pursue.createdAt).format('YYYY-MM-DD HH:mm')}}
                  </span>
                  <span class="col-12">
                    <span class="is-bold fa fa-user"> </span> {{pursue.creator}}
                  </span>
                </div>
                <div class="col-2 clickable" style="color: #29C4AA; font-size: 22px" v-if="hasPursuesWriteAccess && parseInt(pursue.status.id) !== 1" @click.prevent="handlePreDeletePursue(pursue)">
                  <span class="fa fa-trash" />
                </div>
              </div>

              <div class="ml-3 mt-2" style="width:90%; height: 2px; background-color: lightgrey"></div>
            </div>

          </div>

        </div>
      </div>
    </va-modal>

    <ConfirmationModal
      v-if="showDeletingModal"
      :title="$t('activities_agenda.agenda.delete_event.title')"
      :body="$t('activities_agenda.agenda.delete_event.body', {name: this.handleSelectedPersonName, start: this.event.start, end: this.event.end})"
      @modal-confirmed="appointmentDeleted"
      @modal-canceled="appointmentDeleteCanceled"/>

    <ConfirmationModal
      v-if="showConfirmDeletePursueModal"
      :title="$t('users.delete')"
      :body="$t('activities_agenda.agenda.delete_pursue.body')"
      @modal-confirmed="confirmPursueDeletion"
      @modal-canceled="cancelPursueDeletion"/>
  </div>
</template>

<script>
import DatePicker from "@/components/common/DatePicker.vue";
import moment from "moment/moment";
import Errors from "@/utils/StandardErrors";
import { ActivitiesAgendaService } from "@/api/ActivitiesAgendaService";
import Multiselect from "vue-multiselect";
import { EMAIL_REGEX } from "@/utils/regex";
import Searchable from "@/components/common/Searchable.vue";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import PeopleSelector from "@/components/activities_agenda/agenda/PeopleSelector.vue";
import { VueTelInput } from "vue-tel-input";
import { WorkActivityService } from "@/api/AuthService";
import { PeopleManagerService } from "@/api/PeopleManagerService";
import ConfirmationModal from "@/components/common/ConfirmationModal.vue";
import FollowUp from '@/components/leads/FollowUp.vue';
import * as countries from 'i18n-iso-countries'
import Vue from 'vue';


export default {
  components: { FollowUp, ConfirmationModal, PeopleSelector, LoadingPlaceholder, DatePicker, Multiselect, VueTelInput },
  props: {
    fromEvent: {
      type: Object,
      required: false
    },
    selectedActivity: {
      type: Object,
      required: false
    },
    selectedEntity: {
      type: Object,
      required: false
    },
    selectedFacility: {
      type: Object,
      required: false
    },
    selectedEvent: {
      type: Object,
      required: false
    },
    event: {
      type: Object,
      required: false
    },
    agendaEvents: {
      type: Array,
      required: false,
      default: []
    },
    isExternalBooking: {
      type: Boolean,
      required: false,
      default: []
    }
  },
  data() {
    return {
      showDeletingModal: false,
      tabValue: 0,
      viewType: ["search", "create"],
      mainTabValue: 0,
      isLoading: false,
      showPeopleTable: false,
      hasMadeFirstRequest: false,
      isSubmitting: false,
      showModal: false,
      canCancel: true,
      vueTelInputRedrawIndex: 0,
      invalidMobilePhone: false,
      form: {
        start: null,
        end: null,
        personId: null,
        bookingTypeId: null,
        bookingType: null,
        paymentTypeId: null,
        paymentType: null,
        leadId: null,
        activityId: null,
        activity: null,
        originEntityId: null,
        originFacilityId: null,
        entityId: null,
        facilityId: null,
        facility: null,
        originFacility: null,
        pursues: null,
      },
      formErrors: new Errors(),
      bookingTypes: [],
      paymentTypes: [],
      personForm: {
        firstName: '',
        country: '',
        lastName: '',
        birthdate: '',
        email: '',
        mobilePhone: '',
        gender: null,
        originEntityId: null,
        taxNr: '',
        healthNr: ''
      },
      selectedPerson: null,
      creatingPerson: false,
      facilitiesOptions: [],
      activitiesOptions: [],
      originEntitiesOptions: [],
      originFacilitiesOptions: [],
      bookingStatuses: [],
      newPursueStatus: null,
      showConfirmDeletePursueModal: false,
      selectedPursueToDelete: null
    };
  },
  created() {
  },
  async mounted() {
    this.showModal = true;
    this.isLoading = true;
    this.facilitiesOptions = this.selectedEntity.facilities;


    if(this.isExternalBooking) {
      //TODO
      this.originEntitiesOptions = [this.$auth.user().entities.find(ent => ent.id === this.$auth.user().entity_id)]

      if(this.originEntitiesOptions.length === 1) {
        this.form.originEntity = this.originEntitiesOptions[0]
        this.form.originEntityId = this.form.originEntity.id

        this.originFacilitiesOptions = this.form.originEntity.facilities
        if(this.originFacilitiesOptions.length === 1) {
          this.form.originFacility = this.originFacilitiesOptions[0]
        }
      }

    }
    if(this.selectedEntity) {
      this.form.entity = this.selectedEntity;
      this.form.entityId = this.form.entity.id;
    }
    if (this.selectedFacility !== null) {
      this.form.facility = this.selectedFacility;
    } else if (this.selectedEntity.facilities.length === 1) {
      this.form.facility = this.selectedEntity.facilities[0];
    }
    if (this.selectedActivity !== null) {
      this.form.activityId = this.selectedActivity.id;
    }
    await this.loadBookingStatuses();
    await this.loadBookingTypes();
    await this.loadPaymentTypes();
    //await this.loadWorkActivities();

    if (this.fromEvent) {
      this.form.start = this.fromEvent.start
      this.form.end = this.fromEvent.end
    }

    if (this.isUpdating) {
      this.selectedPerson = this.event.person
      this.form.personId = this.event.person.id
      this.form.activity = this.activitiesOptions.find(elem => elem.id === this.event.activity.id)
      this.form.facility = this.event.facility
      this.form.bookingType = this.event.bookingType
      this.form.paymentType = this.event.paymentType
      this.form.start = this.event.start
      this.form.end = this.event.end
      this.form.originEntity = this.event.originEntity
      this.form.originEntityId = this.event.originEntity.id
      this.form.originFacility = {...this.originFacilitiesOptions.find(elem => elem.id === this.event.originFacility.id)}
      this.form.originFacilityId = this.event.originFacility.id
      this.form.pursues = this.event.pursues
    }

    if(this.defaultCountrySelection && !this.isUpdating) {
      this.personForm.country = this.defaultCountrySelection
    }

    this.isLoading = false;
  },
  methods: {
    openPeopleManagerPerson(id) {
      this.showModal = false
      setTimeout(() => {
        this.$emit('redirectToPm', {id: id})
      }, 200 )

    },
    getFlagEmoji(countryCode) {
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char =>  127397 + char.charCodeAt());
      return String.fromCodePoint(...codePoints);
    },
    handlePreDeletePursue(pursue) {
      this.selectedPursueToDelete = pursue
      this.showConfirmDeletePursueModal = true
    },
    cancelPursueDeletion: function() {
      this.showConfirmDeletePursueModal = false
      this.selectedPursueToDelete = null
    },
    confirmPursueDeletion: function() {
      if(this.selectedPursueToDelete) {
        this.handleDeletePursue(this.selectedPursueToDelete)
      }
      this.showConfirmDeletePursueModal = false
    },
    handleDeletePursue: function(pursue) {
      ActivitiesAgendaService.deletePursue(pursue.id).then(res => {
        this.form.pursues = res
      }).catch(err => {
        this.showToast(this.$t('entities.messages.error'), this.$store.state.errorToastOptions)
        console.log(err)

      })
    },
    submitPursueStatus: function() {
      if(this.form.id === null || this.newPursueStatus === null) {
        return
      }
      const data = {
        bookingId: parseInt(this.event.id),
        statusId: parseInt(this.newPursueStatus.id)
      }
      ActivitiesAgendaService.createNewPursue(data).then(res => {
        this.newPursueStatus = null
        this.form.pursues = res
      }).catch(err => {
        this.showToast(this.$t('entities.messages.error'), this.$store.state.errorToastOptions)
        console.log(err)
      })
    },
    personSelected: function(person) {
      this.selectedPerson = person;
    },
    remove: function() {
      this.showModal = false
      this.showDeletingModal = true
    },
    appointmentDeleted: async function() {
      this.isSubmitting = true
      try {
        await ActivitiesAgendaService.destroy(this.event.id)
        this.showToast(this.$t('activities_agenda.agenda.delete_event.success'), this.$store.state.successToastOptions)
        this.$emit('eventDeleted')
      } catch (e) {
        console.log(e)
        this.showToast(this.$t('activities_agenda.agenda.delete_event.error'), this.$store.state.errorToastOptions)
      }
      this.isSubmitting = false
    },
    appointmentDeleteCanceled: function () {
      this.showDeletingModal = false
      this.showModal = true
    },
    submit: async function() {
      this.isSubmitting = true;
      let personId = null
      //First determine whether the person needs to be created or not
      if(this.selectedPerson === null) {
        try {
          //Create perso
          let params = {
            ...this.personForm
          }
          //if we are scheduling for a partner (external event) then we need to gather the info of origin entity and origin facility
          //otherwise we are schedulling for "our own" calendar, then we use origin entity = entity and origin facility = facility
          params.originEntityId = this.isExternalBooking ? this.form.originEntityId : this.form.entityId
          params.originFacilityId = this.isExternalBooking ? this.form.originFacilityId : this.form.facilityId
          params.country = params.country.code.toUpperCase()

          const response = await PeopleManagerService.createPerson(params)
          personId = response.data.id
        } catch (e) {
          console.log(e);
          this.isSubmitting = false
          if (e.response.status === 422) {
            this.formErrors.record(e.response.data.errors, 'people.errors.')
            //console.log(e.response.data.errors)
          }else {
            console.log(e)
          }
          this.showToast(this.$t('people_manager.errors.error_creating_person'), this.$store.state.errorToastOptions)
          return
        }
      } else {
        //No need to create, person has been searched and selected
        personId = this.selectedPerson.id
      }

      //Handle event creation
      try {
        let params = {
          ...this.form,
          personId: parseInt(personId)
        }
        //if we are scheduling for a partner (external event) then we need to gather the info of origin entity and origin facility
        //otherwise we are schedulling for "our own" calendar, then we use origin entity = entity and origin facility = facility
        params.originEntityId = this.isExternalBooking ? this.form.originEntityId : this.form.entityId
        params.originFacilityId = this.isExternalBooking ? this.form.originFacilityId : this.form.facilityId

        delete params.facility
        delete params.entity
        delete params.person
        delete params.bookingType
        delete params.payment
        delete params.activity

        if(this.isUpdating){
          const updatedEvent = await ActivitiesAgendaService.updateEvent(this.event.id, params)
          this.showToast(this.$t('activities_agenda.agenda.update_event.success'), this.$store.state.successToastOptions)
          this.$emit('eventCreated', { updatedEvent })
        } else {
          const createdEvent = await ActivitiesAgendaService.createEvent(params)
          this.showToast(this.$t('activities_agenda.agenda.event_created'), this.$store.state.successToastOptions)
          this.$emit('eventCreated', { createdEvent })
        }

        this.isSubmitting = false
      } catch (e) {
        console.log(e);
        this.isSubmitting = false
        this.showToast(this.$t('activities_agenda.agenda.errors.error_creating_event'), this.$store.state.errorToastOptions)
      }
    },
    cancel: function() {
      if (this.canCancel) {
        setTimeout(() => {
          this.$emit("cancel");
        }, 200);
      }
    },
    loadBookingStatuses: async function() {
      try {
        this.bookingStatuses = await ActivitiesAgendaService.getAllBookingStatuses();
      } catch (e) {
        console.log(e)
      }
    },
    loadBookingTypes: async function() {
      try {
        this.bookingTypes = await ActivitiesAgendaService.getBookingTypes();
      } catch (err) {
        console.log("Error retrieving booking types")
        console.log(err);
      }
    },
    loadPaymentTypes: async function() {
      try {
        this.paymentTypes = await ActivitiesAgendaService.getPaymentTypes();
      } catch (err) {
        console.log("Error retrieving payment types")
        console.log(err);
      }
    },
    loadWorkActivities: async function() {
      try {
        const workActivities = await WorkActivityService.query(this.form.entityId);
        this.activitiesOptions = workActivities.filter(act => act.provider.id === this.form.entityId && act.entity.id === this.form.entityId);
        if (this.activitiesOptions.length > 0) {
          this.activitiesOptions = this.activitiesOptions.map(elem => elem.activity);
        }
      } catch (err) {
        console.log("Error retreaving workActivities")
        console.log(err);
      }
    },
    mobilePhoneValidation: function (data) {
      this.invalidMobilePhone = !data.isValid
      if (data.isValid) {
        this.personForm.mobilePhone = data.number.international
      }
    }
  },
  computed: {
    peopleManagerService: function() {
      return this.$store.state.services.find(service => service.url === this.$store.state.people_manager_server) || null
    },
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
    /*countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let tempCountries = countries.getNames(Vue.i18n.locale().toLowerCase() === 'gb' ? 'en' : Vue.i18n.locale().toLowerCase())
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
    },*/
    activitiesAgendaService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.activities_agenda_server)
    },
    entitiesRead: function () {
      const entitiesIds = this.activitiesAgendaService.user_permissions.filter(perm => perm.access_type >= 1).map(elem => elem.entity_id)
      if(entitiesIds.some(elem => elem === null)) {
        return this.activitiesAgendaService.entities
      }
      return this.activitiesAgendaService.entities.filter(ent => entitiesIds.includes(ent.id) ) || []
    },
    entitiesWrite: function () {
      const entitiesIds = this.activitiesAgendaService.user_permissions.filter(perm => perm.access_type >= 2).map(elem => elem.entity_id)
      if(entitiesIds.some(elem => elem === null)) {
        return this.activitiesAgendaService.entities
      }
      return this.activitiesAgendaService.entities.filter(ent => entitiesIds.includes(ent.id) ) || []
    },
    hasPursuesReadAccess: function () {
      return this.form.entity !== null
        && this.activitiesAgendaService.user_permissions.some(perm => perm.info_type === 120 && perm.access_type >= 1 && this.entitiesRead.map(elem => elem.id).includes(perm.entity_id))
    },
    hasPursuesWriteAccess: function () {
      return this.form.entity !== null
        && this.activitiesAgendaService.user_permissions.some(perm => perm.info_type === 120 && perm.access_type >= 2 && this.entitiesWrite.map(elem => elem.id).includes(perm.entity_id))
    },
    mainViewType: function() {
      //check has pursues pernissions
      return this.isUpdating && (this.hasPursuesReadAccess || this.hasPursuesWriteAccess) ? ["eventDetails", "statusHistory"] : ["eventDetails"]
    },
    isUpdating: function () {
      return this.event !== null && this.event !== undefined
    },
    modalTitle: function() {
      if (this.isUpdating) {
        return `${this.$t("activities_agenda.agenda.edit_event")} - (${this.handleSelectedPersonName})`;
      }
      return `${this.$t("activities_agenda.agenda.new_event")}`;
    },
    handleSelectedPersonName: function() {
      if (!this.selectedPerson) return "N/A";
      let str = "";
      str += this.selectedPerson.firstName;
      if (this.selectedPerson.lastName) {
        str += " ";
        str += this.selectedPerson.lastName;
      }
      return str;
    },
    showPersonForm: function() {
      return this.creatingPerson || this.selectedPerson !== null;
    },
    canSubmitForm: function() {
      if(this.isUpdating && !this.hasUpdatedOriginal ) {
        return false
      }

      if (this.form.start === null
        || this.form.end === null
        || this.form.activityId === null
        || this.form.bookingTypeId === null
        || this.form.paymentTypeId === null
        || this.form.facilityId === null
        || (this.isExternalBooking && this.form.originFacilityId === null )
        || (!this.isExternalBooking && this.form.facilityId === null)) {
        return false;
      }


      if(this.isUpdating){
        if(this.form.originEntityId === null || this.form.originFacilityId === null) {
          return false
        }
      }
      //View type 0 is for patient selection/search, 1 is for creation
      if (this.tabValue === 0 && this.selectedPerson === null) {
        return false;
      } else if (this.tabValue === 1 && (this.personForm.firstName === '' || this.personForm.lastName === '' || this.personForm.birthdate === ''
      || (this.personForm.healthNr === ''))) {
        return false;
      }
      //check email ok and phone ok if exists
      if(this.personForm.email && this.invalidEmail) {
        return false
      }
      if(this.personForm.mobilePhone && this.invalidMobilePhone) {
        return false
      }

      if(this.tabValue === 1 && (this.personForm.mobilePhone === null || this.personForm.mobilePhone === '') && (this.personForm.email === null || this.personForm.email === '')) {
        return false
      }

      return !this.formErrors.any();


    },
    invalidEmail: function () {
      if (this.personForm.email ) {
        if(!this.personForm.email.match(EMAIL_REGEX)) {
          this.formErrors.set('email', 'people.errors.email_must_be_a_valid_email')
          return true
        }
      }
      return false
    },
    selectedLanguage: function() {
      return this.$i18n.locale();
    },
    birthdatePickerConfig: function() {
      return {
        enableTime: false,
        maxDate: moment().toDate(),
        noCalendar: false,
        dateFormat: "Y-m-d"
      };
    },
    datePickerConfig: function() {
      return {
        enableTime: true,
        minTime: moment("08:00:00").format("HH:mm:ss"),
        maxTime: moment("19:00:00").format("HH:mm:ss"),
        time_24hr: true,
        minuteIncrement: 15,
        noCalendar: false,
        dateFormat: "Y-m-d H:i:S"
      };
    },
    invalidName: function() {
      if (this.form.firstName) {
        return this.form.firstName.length < 2;
      }
      return false;
    },
    authUserEntity: function() {
      return this.$auth.user().entity;
    },
    defaultTelCountrySelection: function() {
      if (this.authUserEntity && this.authUserEntity.country) {
        return this.authUserEntity.country
      }
      return this.$store.state.countries.default;
    },
    defaultCountrySelection: function() {
      if (this.authUserEntity && this.authUserEntity.country) {
        const foundCountry = this.countries.find(country => country.code.toUpperCase() === this.authUserEntity.country.toUpperCase())
        if(foundCountry) {
          return foundCountry
        }
      }
      return null
    },
    hasUpdatedOriginal: function() {
      if(this.isUpdating) {
        if(this.selectedPerson && parseInt(this.selectedPerson.id) !== this.event.person.id) {
          return true
        }
        if(this.selectedPerson === null && this.personForm.birthdate !== null) {
          return true
        }
        return this.event.start !== this.form.start
        || this.event.end !== this.form.end
        || (this.isExternalBooking && this.event.originFacility.id !== this.form.originFacilityId)
        || this.event.facility.id !== this.form.facilityId
        || this.event.bookingType.id !== this.form.bookingTypeId
          || (this.event.paymentType && (this.event.paymentType.id !== this.form.paymentTypeId))
      }
      return false
    }
  },
  filters: {
    parseBirthdate: function(value) {
      if (!value || value === "") return "";
      let date = moment(value, "YYYY-MM-DD HH:mm:ss");
      return date.isValid() ? date.format("DD/MM/YYYY") : "";
    }
  },
  watch: {
    "form.start": function(value) {
      this.formErrors.clear('start')
      if (value === null) {
        this.form.end = null;
      }

      if(value !== null) {
        const momentValue = moment(value)
        if((this.isUpdating && this.event && this.form.start !== this.event.start)
        || !this.isUpdating && !this.event) {
          this.form.end = momentValue.clone().add(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
        }

        let eventsForSameDay = []
        if(this.isUpdating) {
          eventsForSameDay = this.agendaEvents.filter(event => moment(event.start).isSame(momentValue, 'day') && parseInt(event.id) !== parseInt(this.event.id))
        } else {
          eventsForSameDay = this.agendaEvents.filter(event => moment(event.start).isSame(momentValue, 'day'))
        }

        if(eventsForSameDay.length > 0 ) {
          if (eventsForSameDay.some(event => momentValue.isBetween(moment(event.start), moment(event.end), 'minute',))) {
            console.log("Start time is between an already scheduled slot")
            this.formErrors.set('start', "activities_agenda.errors.time_must_not_collide_with_scheduled")
          }
        }


        const momentEnd = moment(this.form.end, 'YYYY-MM-DD hh:mm:ss')
        if (this.form.end !== null && momentValue.isSameOrAfter(momentEnd, 'minute')) {
          this.formErrors.set("start", "activites_agenda.errors.start_must_be_before_end");
        }
      }

    },
    "form.end": function(value) {
      if (value !== null) {
        const momentValue = moment(value)
        let eventsForSameDay = []
        if(this.isUpdating) {
          eventsForSameDay = this.agendaEvents.filter(event => moment(event.end).isSame(momentValue, 'day') && parseInt(event.id) !== parseInt(this.event.id))
        } else {
          eventsForSameDay = this.agendaEvents.filter(event => moment(event.end).isSame(momentValue, 'day'))
        }
        if(eventsForSameDay.length > 0) {
          if(eventsForSameDay.some(event => momentValue.isBetween(moment(event.start), moment(event.end), 'minute'))) {
            console.log("End time is between an already scheduled slot")
            this.formErrors.set('end', "activities_agenda.errors.time_must_not_collide_with_scheduled")
          }
        }

        if (this.form.start !== null && momentValue.isSameOrBefore(moment(this.form.start), 'minute')) {
          this.formErrors.set("end", "activities_agenda.errors.end_must_be_after_start");
        }
      }
    },
    "form.originEntity": function(value) {
      if(value) {
        this.form.originEntityId = value.id
        this.originFacilitiesOptions = value.facilities
        if(value.facilities.length === 1) {
          this.form.originFacility = value.facilities[0]
          this.form.originFacilityId = value.facilities[0].id
        }
      } else {
        this.originFacilitiesOptions = []
        this.form.originEntityId = null
      }
    },
    "form.originFacility": function(value) {
      if(value !== null) {
        this.form.originFacilityId = value.id
      } else {
        this.form.originFacilityId = null
      }
    },
    "form.entity": function(value) {
      if (value !== null) {
        this.form.entityId = value.id
      } else {
        this.form.entityId = null
      }
    },
    "form.facility": function(value) {
      if(value !== null && value !== undefined) {
        this.form.facilityId = value.id
      } else {
        this.form.facilityId = null
      }
    },
    "form.bookingType": function(value) {
      if (value !== null) {
        this.form.bookingTypeId = value.id
      } else {
        this.form.bookingTypeId = null
      }
    },
    "form.paymentType": function(value) {
      if (value !== null) {
        this.form.paymentTypeId = value.id
      } else {
        this.form.paymentTypeId = null
      }
    },
    tabValue: function(value) {
      if (value !== null) {
        //whenever value changes, remove the current selectedPerson, if exists
        this.selectedPerson = null
      }
    }
  }
};
</script>

<style lang="scss">
.table-container {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

</style>
